import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import IframeResizer from 'iframe-resizer-react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { dataFeedsUrlSelector } from '../../../AdviserArea/AdviserAreaSelector';

export const DataFeedsSettings = () => {
  const dataFeedsUrl = useSelector(dataFeedsUrlSelector);
  const [isLoading, setIsLoading] = useState(true);

  if (!dataFeedsUrl) {
    return null;
  }

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column">
      {isLoading && (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <Loading text="Loading Data Feeds Settings..." />
        </Box>
      )}
      <IframeResizer
        src={dataFeedsUrl}
        checkOrigin={false}
        style={{ flex: 1, border: 'none', display: isLoading ? 'none' : 'block' }}
        onLoad={handleIframeLoad}
      />
    </Box>
  );
};
